<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!--산업안전보건위원회 회의록 기본정보-->
          <c-card title="LBL0010201" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!--회의제목-->
                <c-text
                  required
                  :editable="editable"
                  label="LBL0010198"
                  name="proceedingsTitle"
                  v-model="data.proceedingsTitle">
                </c-text>
              </div>
              <!--회의일-->
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-datepicker
                  required
                  :editable="editable"
                  label="LBL0010199"
                  name="proceedingsDate"
                  v-model="data.proceedingsDate">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-plant
                  required
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-table
            ref="grid"
            title="회의결과"
            :columns="grid.columns"
            gridHeight="400px"
            :data="data.opinions"
            :filtering="false"
            :columnSetting="false"
            :usePaging="false"
            noDataLabel="회의결과를 등록하세요"
            :hideBottom="true"
            :checkClickFlag="false"
            :isExcelDown="false"
            :editable="editable"
            rowKey="proceedingsOpinionId"
            selection="multiple"
          >
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <!--내부참석자 목록-->
          <!--내부참석자를 추가하세요.-->
          <c-table
            ref="inTable"
            title="LBL0010203"
            :columns="inGrid.columns"
            gridHeight="260px"
            :data="data.attendeeInModels"
            :filtering="false"
            :columnSetting="false"
            :usePaging="false"
            noDataLabel="MSG0010010"
            :hideBottom="true"
            :editable="editable"
            :checkClickFlag="false"
            :isExcelDown="false"
            rowKey="proceedingsAttendeeId"
            selection="multiple"
          >
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <!--외부참석자 목록-->
          <!--외부참석자를 추가하세요.-->
          <c-table
            ref="outTable"
            title="LBL0010204"
            :columns="outGrid.columns"
            gridHeight="260px"
            :data="data.attendeeOutModels"
            :filtering="false"
            :columnSetting="false"
            :usePaging="false"
            noDataLabel="MSG0010011"
            :hideBottom="true"
            :checkClickFlag="false"
            :isExcelDown="false"
            :editable="editable"
            rowKey="proceedingsAttendeeId"
            selection="multiple"
          >
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <!--관련 회의록-->
          <c-card title="첨부파일" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <!--관련 회의록-->
                <c-upload 
                  :attachInfo="attachInfo"
                  :editable="editable"
                  label="첨부파일">
                </c-upload>
              </div>
            </template>
          </c-card>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'proceedings-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        proceedingsId: '',
      }),
    },
  },
  data() {
    return {

      attachable: false,
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'OSH_PROCEEDINGS',
        taskKey: '',
      },
      saveUrl: transactionConfig.sai.osh.proceedings.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      data: {
        proceedingsId: '',
        plantCd: '',
        proceedingsDate: '',
        proceedingsContents: '',
        proceedingsTitle: '',
        regUserId: '',
        chgUserId: '',
        approvalStatusCd: '',
        sysApprovalRequestId: '',
        
        attendeeInModels: [],
        attendeeOutModels: [],
        deleteAttendeeInModels: [],
        deleteAttendeeOutModels: [],
        opinions: [],
        deleteopinions: [],
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: 'opinion',
            field: 'opinion',
            label: '회의결과',
            style: 'width: 80%',
            type: 'textarea',
            align: 'left',
          },
          {
            name: 'remark',
            field: 'remark',
            label: '찬반여부',
            type: 'select',
            comboItems: [
              { code: 'Y', codeName: '찬성' },
              { code: 'N', codeName: '반대' },
            ],
            align: 'left',
          },
        ],
        data: [],
      },
      inGrid: {
        columns: [
          {
            name: 'attendeeDeptName',
            field: 'attendeeDeptName',
            //부서
            label: 'LBLDEPT',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'attendeeUserName',
            field: 'attendeeUserName',
            //이름
            label: 'LBLNAME',
            style: 'width: 80px',
            align: 'center',
          },
          {
            name: 'attendeeJobName',
            field: 'attendeeJobName',
            //직책
            label: 'LBLPOSITION',
            style: 'width: 80px',
            align: 'center',
          },
          {
            name: 'remark',
            field: 'remark',
            //비고
            label: 'LBLREMARK',
            type: 'textarea',
            align: 'center',
            style: 'width: 200px',
          },
        ],
        data: [],
      },
      outGrid: {
        columns: [
          {
            name: 'attendeeBelong',
            field: 'attendeeBelong',
            //소속
            label: 'LBL0010206',
            type: 'text',
            align: 'center',
            style: 'width: 80px',
            required: true,
          },
          {
            name: 'attendeeUserName',
            field: 'attendeeUserName',
            //이름
            label: 'LBLNAME',
            style: 'width: 80px',
            type: 'text',
            required: true,
            align: 'center',
          },
          {
            name: 'attendeeJobName',
            field: 'attendeeJobName',
            //직책
            label: 'LBLPOSITION',
            type: 'text',
            style: 'width: 80px',
            align: 'center',
          },
          {
            name: 'remark',
            field: 'remark',
            //비고
            label: 'LBLREMARK',
            type: 'textarea',
            align: 'center',
            style: 'width: 200px',
          },
        ],
        data: [],
      },
      realKey: '',
      isApproval: false,
    };
  },
  computed: {
    isOld() {
      return Boolean(this.popupParam.proceedingsId)
    },
    disabled() {
      return Boolean(this.data.approvalStatusCd)
    },
    approvalInfo() {
      return {
        sysApprovalRequestId: this.data.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.data.approvalStatusCd, 
        apprEditable: this.isOld, // 결재버튼 활성화 기준
        param: this.data, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000021', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          proceedingsId: this.data.proceedingsId,
          isApprContent: true
        },
        approvalRequestName: '[산업안전보건위원회]' + this.data.proceedingsTitle, // 결재요청명 (문서 title)
        approvalConnId: this.data.proceedingsId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = false;
      
      this.data.proceedingsDate = this.$comm.getToday();
      // url setting
      this.detailUrl = selectConfig.sai.osh.proceedings.get.url;
      this.insertUrl = transactionConfig.sai.osh.proceedings.insert.url;
      this.updateUrl = transactionConfig.sai.osh.proceedings.update.url;
      this.deleteUrl = transactionConfig.sai.osh.proceedings.delete.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.proceedingsId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.proceedingsId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = _result.data;
          // 상세팝업 최초작성/최근수정 정보 노출
          this.$emit('setRegInfo', _result.data)
          this.$set(this.attachInfo, 'taskKey', this.popupParam.proceedingsId)
          this.attachable = true;
        },);
      }
    },
    saveData() {
      if (this.popupParam.proceedingsId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          let selectData = this.data.attendeeOutModels;
          let isConti = true;
          let checkItem = ['attendeeBelong', 'attendeeUserName']
          this.$_.forEach(selectData, item => {
            this.$_.forEach(checkItem, check => {
              if (!item[check]) {
                isConti = false;
                return false;
              }
            })
          }); 
          if (!isConti) {
            window.getApp.$emit('ALERT', {
              title: 'LBLGUIDE', // 안내
              message: 'MSG0010012',  // 필수 입력값을 입력해 주세요. [소속, 이름]
              type: 'warning', // success / info / warning / error
            });
          } else {
            window.getApp.$emit('CONFIRM', {
              title: 'LBLCONFIRM',  // 확인
              message: 'MSGSAVE', // 저장하시겠습니까?   // 저장하시겠습니까?
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.data.regUserId = this.$store.getters.user.userId;
                this.data.chgUserId = this.$store.getters.user.userId;

                this.isSave = !this.isSave;
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    removeData() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',  // 확인
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.proceedingsId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      
      if (!this.isOld) {
        this.$set(this.popupParam, 'proceedingsId', result.data)
        this.$set(this.attachInfo, 'taskKey', this.popupParam.proceedingsId)
        this.$set(this.attachInfo, 'isSubmit', uid())
      }

      this.getDetail();
    },
    addInAttendee() {
      this.popupOptions.title = "LBL0010207"; // 내부참석자 검색
      this.popupOptions.param = {
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '60%';
      this.popupOptions.isFull = false;
      this.popupOptions.closeCallback = this.closeUserPopup;

    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.data.attendeeInModels, {
            attendeeUserId: _item.userId,
          });
          if (index === -1) {
            this.data.attendeeInModels.splice(0, 0, {
              proceedingsId: this.popupParam.proceedingsId,
              proceedingsAttendeeId: uid(),
              attendeeType: '1',
              attendeeUserId: _item.userId,
              attendeeUserName: _item.userName,
              attendeeDeptName: _item.deptName,
              attendeeJobName: _item.jobName,
              remark: '',
              chgUserId: this.$store.getters.user.userId,
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C'
            })
          }
        })
      }
    },
    removeInAttendee() {
      let selectData = this.$refs['inTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.data.deleteAttendeeInModels) {
            this.data.deleteAttendeeInModels = []
          }
          if (this.$_.findIndex(this.data.deleteAttendeeInModels, { proceedingsAttendeeId: item.proceedingsAttendeeId }) === -1
            && item.editFlag !== 'C') {
              this.data.deleteAttendeeInModels.push(item)
          }
          this.data.attendeeInModels = this.$_.reject(this.data.attendeeInModels, item)
        })
      }
    },
    addOutAttendee() {
      this.data.attendeeOutModels.splice(0, 0, {
        proceedingsId: this.popupParam.proceedingsId,
        proceedingsAttendeeId: uid(),
        attendeeType: '2',
        attendeeUserId: '',
        attendeeUserName: '',
        attendeeJobName: '',
        remark: '',
        attendeeBelong: '',
        chgUserId: this.$store.getters.user.userId,
        regUserId: this.$store.getters.user.userId,
        editFlag: 'C'
      })
    },
    removeOutAttendee() {
      let selectData = this.$refs['outTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.data.deleteAttendeeOutModels) {
            this.data.deleteAttendeeOutModels = []
          }
          if (this.$_.findIndex(this.data.deleteAttendeeOutModels, { proceedingsAttendeeId: item.proceedingsAttendeeId }) === -1
            && item.editFlag !== 'C') {
              this.data.deleteAttendeeOutModels.push(item)
          }
          this.data.attendeeOutModels = this.$_.reject(this.data.attendeeOutModels, item)
        })
      }
    },
    addOpinion() {
      this.data.opinions.push({
        proceedingsId: this.popupParam.proceedingsId,
        proceedingsOpinionId: uid(),
        opinion: '',
        remark: '',
        editFlag: 'C'
      })
    },
    removeOpinion() {
      let selectData = this.$refs['grid'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.data.deleteopinions) {
            this.data.deleteopinions = []
          }
          if (this.$_.findIndex(this.data.deleteopinions, { proceedingsOpinionId: item.proceedingsOpinionId }) === -1
            && item.editFlag !== 'C') {
              this.data.deleteopinions.push(item)
          }
          this.data.opinions = this.$_.reject(this.data.opinions, item)
        })
      }
    },
    saveDataAppr() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',  // 확인
            message: '결재요청을 진행하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.isApproval = !this.isApproval
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    // [S] 결재관련 
    approvalCallback() { // 결재관련 결재요청버튼 callback
      this.$refs['appr-btn'].apprRequestPop();
    },
  }
};
</script>
